if(!customElements.get('scrollable-icons')) {
  class ScrollableIcons extends HTMLElement {
    constructor() {
      super();
      this.scrollableArea = this.querySelector('.text-with-icons__blocks');
      this.dots = [...document.querySelectorAll('.text-with-icons__scrollable-icons-slider-dots .dot')];

      this.scrollHandler = this.updateDots.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.scrollableArea.addEventListener('scroll', this.scrollHandler);
      this.dots.forEach(dot => dot.addEventListener('click', this.handleClick));
    }
    
    disconnectedCallback() {
      this.scrollableArea.removeEventListener('scroll', this.scrollHandler);
      this.dots.forEach(dot => dot.removeEventListener('click', this.handleClick));
    }

    updateDots() {
        const index = Math.round(this.scrollableArea.scrollLeft / this.scrollableArea.offsetWidth);
        this.dots.forEach(dot => dot.classList.remove("active"));
        if (this.dots[index]) this.dots[index].classList.add("active");
    }

    handleClick(event) {
        const dot = event.target;
        const index = parseInt(dot.dataset.index);
        this.scrollableArea.scrollTo({ left: index * this.scrollableArea.offsetWidth, behavior: "smooth" });
    }
  }
  customElements.define('scrollable-icons', ScrollableIcons);
}